import {Component, Input, OnInit} from '@angular/core';
import {AdditionalQuestionOption, Assessment} from '../../models/models.lib';
import {
  AbstractControl,
  ControlContainer,
  FormArray,
  FormBuilder, FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule
} from '@angular/forms';
import {LoggerService} from '../../shared/logger.service';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {RESPONSE_TYPES} from '../../common/constants.lib';

@Component({
  selector: 'casi-assessment-additional-answer',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ],
  standalone: true,
  templateUrl: './assessment-additional-answer.component.html',
  styleUrl: './assessment-additional-answer.component.scss'
})
export class AssessmentAdditionalAnswerComponent implements OnInit {
  private _assessment: Assessment| undefined;

  @Input({ required: true }) set assessment(val: Assessment) {
    this._assessment = val;
  }
  get assessment(): Assessment | undefined {
    return this._assessment;
  };

  @Input({ required: true }) assessmentForm!: FormGroup;

  responseTypes: string[] = RESPONSE_TYPES;

  constructor(
    private logger: LoggerService,
    private fb: FormBuilder
  ) {}

  // //#region Form
  get additionalAnswersArray(): FormArray<FormGroup> {
    return this.assessmentForm.get('additional_answers') as FormArray<FormGroup>;
  }
  getAnswerControl(q: FormGroup, name: string): FormControl {
    return q.get(name) as FormControl;
  }

  getOptions(d: FormGroup): AdditionalQuestionOption[] {
    return d.get('options')?.value ?? [];
  }
  // //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');

  }

  getStep(d: FormGroup): number {
    const decimals = d.get('decimal_places')?.value;

    if (decimals === null || decimals === undefined)
      return 1;

    const n = Number(decimals);

    if (isNaN(n) || n < 0)
      return 1;

    return Number(`1e-${n}`);
  }


  //checkboxes
  // getValue(d: FormGroup): boolean[] {
  //   const v = d.get('value')?.value;
  //   if (!v) return []; // copre "", null, undefined
  //   return Array.isArray(v) ? v : [v];
  // }

  getValue(d: FormGroup): boolean[] {
    const v = d.get('value')?.value;

    if (!v) return [];
    if (Array.isArray(v)) return v;

    // caso stringa tipo "[false, true, true]"
    if (typeof v === 'string')
      try {
        const parsed = JSON.parse(v);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [v as unknown as boolean];
      }

    return [v];
  }

  isChecked(d: FormGroup, index: number): boolean {
    return this.getValue(d)[index] === true;
  }

  toggleCheckbox(d: FormGroup, index: number, checked: boolean): void {
    const control = d.get('value');
    if (control?.disabled) return;

    const value = this.getValue(d);
    // garantisce array della stessa lunghezza delle options
    if (value.length < index + 1) {
      value[index] = false;
    }

    value[index] = checked;

    d.get('value')?.setValue([...value]);
    d.get('value')?.markAsTouched();
  }

  // isRequiredInvalid(d: FormGroup): boolean {
  //   const value = this.getValue(d);
  //   const required = d.get('compulsory')?.value;
  //
  //   if (!required) return false;
  //
  //   return !value || value.length === 0 || !value.some(v => v === true);
  // }
}
